module.exports = __webpack_public_path__ + "../resources/images/SkyCode_41-9d3bc7d3f4553e41583b7d7ea30ae350.svg";